<template>
    <field-wrapper
        id="customerDeliveryCity"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerDeliveryCity_input"
            v-model="value"
            type="text"
            autocomplete="address-level2"
            aria-describedby="customerDeliveryCity_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_delivery_city");
        },
        value: {
            get() {
                return this.city || "";
            },
            set(deliveryCity) {
                this.updateCustomer({ deliveryCity });
            }
        },
        errorMessage() {
            if (this.validate && this.error)
                return this.$t(
                    `field_customer_delivery_city.${this.error}`,
                    1,
                    {
                        invalidChars: this.invalidChars.join("")
                    }
                );
            return null;
        },
        ...mapGetters({
            city: "customer/getDeliveryCity",
            invalidChars: "customer/getDeliveryCityInvalidChars",
            error: "customer/getDeliveryCityError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
